import ShellPartnerModel from './ShellPartnerModel';

class ShellPartnersModel {
  partners;

  constructor(partners = []) {
    this.partners = partners.map(p => new ShellPartnerModel(p));
  }
}

export default ShellPartnersModel;
